import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .formBottomHashtag {
    display: flex;
    gap: 0.5rem;
    margin-top: 1rem;
    align-items: flex-end;
    flex-wrap: wrap;
  }
  .formBottomHashtag .selectWritingTone {
    width: 200px;
  }
  .formClassMain {
    display: flex;
    padding: 1.5rem;
  }
  .secondFormHashForm {
    min-width: 250px;
    padding: 1rem;
    border-left: 1px solid #dee2e6;
  }
  .generatingButton991 {
    background-color: #8cc540;
    border-color: #8cc540;
    color: white;
    min-width: 17rem;
    margin-left: auto;
  }
  .generatingButton320 {
    background-color: #8cc540;
    border-color: #8cc540;
    color: white;
    min-width: 100%;
    margin-left: auto;
    display: none;
  }
  .resultBoxHashtag {
    padding: 1.5rem;
  }
  @media (max-width: 1400px) {
    .formBottomHashtag . {
    }
    .formBottomHashtag .selectWritingTone {
      width: 100%;
    }
    .formBottomHashtag .captionStyleCss {
      width: 100%;
    }
  }
  @media (max-width: 991px) {
    .generatingButton991 {
      display: none;
    }
    .generatingButton320 {
      display: block;
    }
    .resultBoxHashtag {
      padding: 0.5rem;
    }
    .formClassMain {
      display: block;
      padding: 0.5rem;
    }
    .secondFormHashForm {
      margin-top: 0.5rem;
      min-width: 100%;
      padding: 0;
      border-left: 0px solid #dee2e6;
    }
  }

  .format-radio-wrapper {
  padding-left: 2px;
}
  .format-radio-wrapper {
  padding-left: 2px;
}
  .format-radio-wrapper .form-check {
  padding-left: 1.8rem; 
}
`;
